import { Chip, Stack } from '@mui/material';

export interface TagsListProps {
    /**
     * Array of tag labels to display
     */
    tags: string[];
}

export default function TagsList({ tags }: TagsListProps) {
    return (
        <Stack
            direction="row"
            gap={ 1 }
            flexWrap="wrap"
        >
            { tags.map(tag => (
                <Chip variant="outlined"
                    key={ tag }
                    label={ tag }
                />
            )) }
        </Stack>
    );
}
